import * as config from "../app.config";
import { USER_MESSAGE, setHeaders } from "./User";
import axios from "axios";
//import _ from "underscore";
import moment from "moment";
import * as utils from "../utils/basic";

export const POST_FILE = "POST_FILE";
export const SET_CLEAR_SAMPLE_DETAIL = "SET_CLEAR_SAMPLE_DETAIL";
export const FETCH_SAMPLES = "FETCH_SAMPLES";
export const FETCH_SAMPLE_DETAIL = "FETCH_SAMPLE_DETAIL";
export const SET_JOBID = "SET_JOBID";
export const SET_SAMPLE_URL = "SET_SAMPLE_URL";
export const SET_SAMPLE_DELETE_CONFIRM = "SET_SAMPLE_DELETE_CONFIRM";
export const SET_SAMPLE_DELETE_CANCEL = "SET_SAMPLE_DELETE_CANCEL";
export const SET_SAMPLE_DELETE_SUCCESS = "SET_SAMPLE_DELETE_SUCCESS";
export const SET_CLEAR_ADD_SAMPLE = "SET_CLEAR_ADD_SAMPLE";
export const SET_SAMPLE_ID = "SET_SAMPLE_ID";
export const SET_SAMPLE_FILES = "SET_SAMPLE_FILES";

function _handleErrors(err) {
  return dispatch => {
    const status = (err && err.response && err.response.status) || 401;
    switch (status) {
      case 401:
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Invalid or expired session, please login again",
          key: moment().unix()
        });
        //dispatch(handleLogout());
        break;
      case 409:
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Item already exists",
          key: moment().unix()
        });
        break;
      case 403:
        //dispatch(handleLogout());
        break;
      default:
    }
  };
}

export function fetchSampleList(samplePurpose) {
  return (dispatch, getState) => {
    const headerConfig = setHeaders();
    dispatch({ type: FETCH_SAMPLES, payload: {} });

    axios
      .get(`${config.ENDPOINTS["main"]}/sample/${samplePurpose}/list`, {
        headers: headerConfig
      })
      .then(resp => {
        dispatch({ type: FETCH_SAMPLES, payload: resp.data });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function fetchSample(sampleId) {
  return (dispatch, getState) => {
    axios
      .get(`${config.ENDPOINTS["main"]}/sample/${sampleId}`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: FETCH_SAMPLE_DETAIL,
          payload: resp.data,
          sampleId
        });
        dispatch({ type: SET_SAMPLE_ID, sampleId: sampleId });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function clearAddSample() {
  return dispatch => {
    dispatch({ type: SET_CLEAR_ADD_SAMPLE });
  };
}

export function clearSampleDetail() {
  return dispatch => {
    dispatch({ type: SET_CLEAR_SAMPLE_DETAIL });
  };
}

export function deleteUserSampleConfirm(sampleId) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SAMPLE_DELETE_CONFIRM, sampleId });
  };
}

export function deleteUserSampleCancel() {
  return (dispatch, getState) => {
    dispatch({ type: SET_SAMPLE_DELETE_CANCEL });
  };
}

export function deleteUserSample(sampleId, samplePurpose) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_SAMPLE_DELETE_SUCCESS
    });

    axios
      .delete(`${config.ENDPOINTS["main"]}/sample/${sampleId}`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch(fetchSampleList(samplePurpose));
      })
      .then(() => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Sample deleted successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function addSampleTag(sampleId, tagId) {
  return (dispatch, getState) => {
    axios
      .post(
        `${config.ENDPOINTS["main"]}/sample/${sampleId}/tagId/${tagId}`,
        {},
        { headers: setHeaders() }
      )
      .then(() => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Successfully added tag to this sample",
          key: moment().unix()
        });
        dispatch(fetchSample(sampleId));
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function deleteSampleTag(sampleId, tagId) {
  return (dispatch, getState) => {
    axios
      .delete(`${config.ENDPOINTS["main"]}/sample/${sampleId}/tagId/${tagId}`, {
        headers: setHeaders()
      })
      .then(() => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Successfully removed tag from this sample",
          key: moment().unix()
        });
        dispatch(fetchSample(sampleId));
        dispatch(fetchSampleList());
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function addSample(values) {
  return (dispatch, getState) => {
    axios
      .post(`${config.ENDPOINTS["main"]}/sample`, values, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Sample added successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function updateSample(sampleId, values) {
  return (dispatch, getState) => {
    axios
      .put(`${config.ENDPOINTS["main"]}/sample/${sampleId}`, values, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Sample updated successfully",
          key: moment().unix()
        });
        dispatch(fetchSample(sampleId));
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function processSampleDetail(values) {
  return (dispatch, getState) => {
    if (!values.existingSample) {
      const {
        samples: { sampleId }
      } = getState();
      var tempVals = values;
      tempVals.id = sampleId;
      dispatch(addSample(tempVals));
    } else {
      dispatch(updateSample(values.id, values));
    }
  };
}

export function createSampleId() {
  return dispatch => {
    dispatch({ type: SET_SAMPLE_ID, sampleId: utils.guidDBG() });
  };
}

export function addSampleFileDbEntry(fileName) {
  return (dispatch, getState) => {
    const {
      samples: { sampleId }
    } = getState();

    const postData = {
      sampleId: sampleId,
      fileName: fileName
    };

    const headerConfig = setHeaders();

    axios
      .post(`${config.ENDPOINTS.main}/addFile`, postData, {
        headers: headerConfig
      })
      .then(resp => {
        dispatch({
          type: SET_SAMPLE_FILES,
          payload: { name: fileName, url: config.ENDPOINTS.s3Bucket }
        });
      })
      .catch(err => {
        console.error("signed url error: ", err);
      });
  };
}

export function uploadSampleFile(signedInfo, file, newFileName) {
  return (dispatch, getState) => {
    var frmData = new FormData();
    const data = signedInfo.data;
    frmData.set("acl", data.upload_fields.fields.acl);
    frmData.set("key", data.upload_fields.fields.key);
    frmData.set("policy", data.upload_fields.fields.policy);
    frmData.set(
      "x-amz-algorithm",
      data.upload_fields.fields["x-amz-algorithm"]
    );
    frmData.set(
      "x-amz-credential",
      data.upload_fields.fields["x-amz-credential"]
    );
    frmData.set("x-amz-date", data.upload_fields.fields["x-amz-date"]);
    frmData.set(
      "x-amz-security-token",
      data.upload_fields.fields["x-amz-security-token"]
    );
    frmData.set(
      "x-amz-signature",
      data.upload_fields.fields["x-amz-signature"]
    );
    frmData.set("file", file, file.name);

    axios({
      method: "post",
      url: config.ENDPOINTS.s3Bucket,
      data: frmData,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(() => {
        dispatch(addSampleFileDbEntry(newFileName));
      })
      .catch(err => {
        console.error("postFile: ", err);
      });
  };
}

export function processSampleFileUpload(file) {
  return (dispatch, getState) => {
    const {
      samples: { sampleId }
    } = getState();

    const headerConfig = setHeaders();
    const fileType = file.type.split("/")[1];
    const newFileName = `${file.lastModified}_${file.name.replace(
      /\W/g,
      "_"
    )}.${fileType}`;

    const postData = {
      bucket_name: config.S3ROOTFOLDER,
      region: config.S3REGION,
      expiration: 3600,
      file_name: newFileName,
      endpoint_url: config.ENDPOINTS.s3BucketRoot,
      file_directory: `${config.S3ENVFOLDER}/${sampleId}`
    };

    return axios
      .post(`${config.ENDPOINTS.main}/signUrl`, postData, {
        headers: headerConfig
      })
      .then(resp => {
        dispatch(uploadSampleFile(resp, file, newFileName, file.size));
      })
      .catch(err => {
        console.error("signed url error: ", err);
      });
  };
}

export function deleteUserSampleFile(sampleId, src) {
  return (dispatch, getState) => {
    var tempFileName = src.split("?")[0];
    tempFileName = tempFileName.split("/");
    const fileName = `${config.S3ENVFOLDER}/${sampleId}/${
      tempFileName[tempFileName.length - 1]
    }`;

    const postData = {
      bucketName: config.S3ROOTFOLDER,
      fileName: fileName
    };

    axios
      .put(`${config.ENDPOINTS["main"]}/deleteFile`, postData, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Sample file updated successfully",
          key: moment().unix()
        });
        //dispatch(fetchSample(sampleId));
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}
